import { useEffect, lazy, Suspense } from 'react';
import {
  BrowserRouter as HashRouter,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import Header from "./components/Layout/Header";
import Footer from "./components/Layout/Footer";

const Home = lazy(() => import("./components/Pages/Home"));
const About = lazy(() => import("./components/Pages/About"));
const GalleryPage = lazy(() => import("./components/Pages/Gallery"));
const ContactUs = lazy(() => import("./components/Pages/ContactUs"));

const HydraulicElevators = lazy(() => import("./components/Pages/product/HydraulicElevators"));
const HospitalElevator = lazy(() => import("./components/Pages/product/HospitalElevator"));
const PassengerElevator = lazy(() => import("./components/Pages/product/PassengerElevator"));
const GoodsElevator = lazy(() => import("./components/Pages/product/GoodsElevator"));
const MRElevator = lazy(() => import("./components/Pages/product/MRElevator"));
const MRLElevator = lazy(() => import("./components/Pages/product/MRLElevator"));
const BungalowElevator = lazy(() => import("./components/Pages/product/BungalowElevator"));

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <HashRouter basename='/' >
      <Header />
      <ScrollToTop />
      <Suspense fallback={<div className="min-h-screen bg-white" />}>
        <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/gallery' element={<GalleryPage />} />
        <Route path='contact-us' element={<ContactUs />} />

        <Route path='hydraulic_elevators' element={<HydraulicElevators />} />
        <Route path='hospital_elevators' element={<HospitalElevator />} />
        <Route path='passenger_elevators' element={<PassengerElevator />} />
        <Route path='goods_elevators' element={<GoodsElevator />} />
        <Route path='mr_elevators' element={<MRElevator />} />
        <Route path='mrl_elevators' element={<MRLElevator />} />
        <Route path='bungalow_elevators' element={<BungalowElevator />} />
      </Routes>
      </Suspense>
      <Footer />
    </HashRouter>
  );
}

export default App;